module.exports = __webpack_public_path__ + "static/media/dr-bot.c07230ed.svg";